export default __webpack_public_path__ + "static/media/Icon_Meet.5d961ec4.svg";